import { toAmericanDate } from '../../../helpers';
import {
  CORE, RELATORIOS, gateway,
} from '../../api';

export function findUsuariosNegociadores() {
  return gateway.get(`${CORE}/analise-gerencial/usuarios-negociador`);
}

export function findRendimentoMensalNegociador(dataBase,
  idUsuarioNegociador,
  tipoConsulta,
  selecionarDosDoisSistemas) {
  const payload = {
    dataReferencia: toAmericanDate(dataBase),
    idUsuarioNegociador,
    tipoConsulta,
    selecionarDosDoisSistemas,
  };
  return gateway.post(`${CORE}/analise-gerencial/rendimento-mensal/negociador/pesquisa`, payload);
}

export function imprimirRendimentoMensalNegociadorExcel(dataBase,
  idUsuarioNegociador,
  tipoConsulta,
  selecionarDosDoisSistemas) {
  const payload = {
    dataReferencia: toAmericanDate(dataBase),
    idUsuarioNegociador,
    tipoConsulta,
    selecionarDosDoisSistemas,
  };
  return gateway.post(`${RELATORIOS}/analise-gerencial/rendimento-mensal/negociador/download/excel`, payload);
}

export function imprimirRendimentoMensalNegociadorPdf(dataBase,
  idUsuarioNegociador,
  tipoConsulta,
  selecionarDosDoisSistemas) {
  const payload = {
    dataReferencia: toAmericanDate(dataBase),
    idUsuarioNegociador,
    tipoConsulta,
    selecionarDosDoisSistemas,
  };
  return gateway.post(`${RELATORIOS}/analise-gerencial/rendimento-mensal/negociador/download/pdf`, payload);
}

export function findUsuariosComerciais() {
  return gateway.get(`${CORE}/analise-gerencial/usuarios-comerciais`);
}

export function findRendimentoMensalComercial(dataBase,
  idUsuarioComercial,
  apenasAtivos,
  selecionarDosDoisSistemas) {
  const payload = {
    dataReferencia: toAmericanDate(dataBase),
    idUsuarioComercial,
    apenasAtivos,
    selecionarDosDoisSistemas,
  };
  return gateway.post(`${CORE}/analise-gerencial/rendimento-mensal/comercial/pesquisa`, payload);
}

export function imprimirRendimentoMensalComercialExcel(dataBase,
  idUsuarioComercial,
  apenasAtivos,
  selecionarDosDoisSistemas) {
  const payload = {
    dataReferencia: toAmericanDate(dataBase),
    idUsuarioComercial,
    apenasAtivos,
    selecionarDosDoisSistemas,
  };
  return gateway.post(`${RELATORIOS}/analise-gerencial/rendimento-mensal/comercial/download/excel`, payload);
}
export function imprimirRendimentoMensalComercialPdf(dataBase,
  idUsuarioComercial,
  apenasAtivos,
  selecionarDosDoisSistemas) {
  const payload = {
    dataReferencia: toAmericanDate(dataBase),
    idUsuarioComercial,
    apenasAtivos,
    selecionarDosDoisSistemas,
  };
  return gateway.post(`${RELATORIOS}/analise-gerencial/rendimento-mensal/comercial/download/pdf`, payload);
}

export function findClientesEmDebito(todosComerciais, idUsuarioComercial, selecionarDosDoisSistemas, statusCliente, debitosAcimaDe) {
  const payload = {
    todosComerciais,
    idUsuarioComercial,
    selecionarDosDoisSistemas,
    statusCliente,
    debitosAcimaDe,
  };
  return gateway.post(`${CORE}/analise-gerencial/clientes-em-debito/pesquisa`, payload);
}

export function findUsuariosComerciaisAtivos() {
  return gateway.get(`${CORE}/analise-gerencial/usuarios-comerciais/ativos`);
}

export function imprimirRelacaoDosClientesEmDebitoExcel(todosComerciais, idUsuarioComercial, selecionarDosDoisSistemas, statusCliente, debitosAcimaDe) {
  const payload = {
    todosComerciais,
    idUsuarioComercial,
    selecionarDosDoisSistemas,
    statusCliente,
    debitosAcimaDe,
  };
  return gateway.post(`${RELATORIOS}/analise-gerencial/clientes-em-debito/download/excel`, payload);
}

export function imprimirRelacaoDosClientesEmDebitoPdf(todosComerciais, idUsuarioComercial, selecionarDosDoisSistemas, statusCliente, debitosAcimaDe) {
  const payload = {
    todosComerciais,
    idUsuarioComercial,
    selecionarDosDoisSistemas,
    statusCliente,
    debitosAcimaDe,
  };
  return gateway.post(`${RELATORIOS}/analise-gerencial/clientes-em-debito/download/pdf`, payload);
}

export function findValoresAPagarPelaAbe(contabilizarClienteInativo,
  exibirTotalizacaoPorCliente,
  exibirApenasClienteComPrestacaoDeContasParaODia,
  dataReferencia,
  selecionarDosDoisSistemas) {
  const payload = {
    contabilizarClienteInativo,
    exibirTotalizacaoPorCliente,
    exibirApenasClienteComPrestacaoDeContasParaODia,
    dataReferencia: toAmericanDate(dataReferencia),
    selecionarDosDoisSistemas,
  };
  return gateway.post(`${CORE}/analise-gerencial/valores-a-pagar-pela-abe/pesquisa`, payload);
}

export function imprimirValoresAPagarPelaAbeExcel(contabilizarClienteInativo,
  exibirTotalizacaoPorCliente,
  exibirApenasClienteComPrestacaoDeContasParaODia,
  dataReferencia,
  selecionarDosDoisSistemas) {
  const payload = {
    contabilizarClienteInativo,
    exibirTotalizacaoPorCliente,
    exibirApenasClienteComPrestacaoDeContasParaODia,
    dataReferencia: toAmericanDate(dataReferencia),
    selecionarDosDoisSistemas,
  };
  return gateway.post(`${RELATORIOS}/analise-gerencial/valores-a-pagar-pela-abe/download/excel`, payload);
}

export function imprimirValoresAPagarPelaAbePdf(contabilizarClienteInativo,
  exibirTotalizacaoPorCliente,
  exibirApenasClienteComPrestacaoDeContasParaODia,
  dataReferencia,
  selecionarDosDoisSistemas) {
  const payload = {
    contabilizarClienteInativo,
    exibirTotalizacaoPorCliente,
    exibirApenasClienteComPrestacaoDeContasParaODia,
    dataReferencia: dataReferencia === null ? null : toAmericanDate(dataReferencia),
    selecionarDosDoisSistemas,
  };
  return gateway.post(`${RELATORIOS}/analise-gerencial/valores-a-pagar-pela-abe/download/pdf`, payload);
}
